import Client from '@/app/repository/axios-client';

export default {
  login(payload) {
    return Client.post(`/login_check`, payload);
  },
  resetPassword(payload) {
    return Client.put(`/reset-password`, payload);
  },
  changePasswordWithToken(payload) {
    return Client.post(`reset-password/change-password`, payload);
  }
};
